import type { ValueOf } from '@shared/lib'

export const NotificationCategory = {
  Requests: 'Requests',
  Users: 'Users',
  Chats: 'Chats',
  Payments: 'Payments',
  Olympiads: 'Olympiads',
  Tasks: 'Tasks',
  Results: 'Results',
  Certificates: 'Certificates',
} as const
export type NotificationCategory = ValueOf<typeof NotificationCategory>

export const NotificationStatus = {
  approved: 'approved',
  declined: 'declined',
} as const
export type NotificationStatus = ValueOf<typeof NotificationStatus>

// FK fields (e.g. city) come as raw ids in old/new plus human-readable
// *_display values — always prefer the display pair when present.
export interface NotificationChange {
  field: string
  old?: string | number | null
  new?: string | number | null
  old_value?: string | null
  new_value?: string | null
  old_display?: string | null
  new_display?: string | null
}

export interface Notification {
  id: number
  title: string
  message?: string | null
  created_at: string
  type_display: NotificationCategory
  actionable?: boolean
  resolved?: boolean
  user_id?: number
  changes?: NotificationChange[] | Record<string, Omit<NotificationChange, 'field'>>
  request?: { difference?: Record<string, unknown> } | null
  payload?: unknown
  /** Client-side resolution, set after the admin approves/declines an actionable
   *  request. Drives the status badge that replaces the action buttons; persists
   *  across WS snapshots so the outcome stays visible. */
  localStatus?: NotificationStatus
}
